import { jsx as _jsx } from "react/jsx-runtime";
import { Result } from "antd";
import { ButtonLink } from "./ButtonLink";
import { useTranslation } from ".";
export function FourOhFour() {
    const { t } = useTranslation("error");
    return (_jsx("div", { children: _jsx(Result, { extra: _jsx(ButtonLink, { href: "/", type: "primary", children: t("common:backHome") }), status: "404", subTitle: t("404"), title: "404" }) }));
}
//# sourceMappingURL=FourOhFour.js.map